import { render } from "./AddCategorieOffreModal.vue?vue&type=template&id=4b265da9&ts=true"
import script from "./AddCategorieOffreModal.vue?vue&type=script&lang=ts"
export * from "./AddCategorieOffreModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__